var exports = {
  "kL": "xe564cbfb--54f5aa--container",
  "m9": "xe564cbfb--54f5aa--advertise",
  "LM": "xe564cbfb--54f5aa--advertise--promo",
  "r_": "xe564cbfb--54f5aa--agents-advertise",
};

module.exports = exports;
